<template>
<div>
    <form>
        <!-- Announcement selection dropdown is available only when adding an announcement/attachment. -->
        <b-form-group v-if="action == 'add'" :label="$t('terminals.announcements.announcement')">
            <vSelect :options="announcementOptions" v-model="announcement.tunnus" :reduce="option => option.tunnus" label="otsikko"
                :selectable="(option) => option.tunnus > -2" @option:selected="onSelect" />
        </b-form-group>
        <label>{{ $t('terminals.announcements.name') }}</label>
        <b-form-input v-model="announcement.otsikko" :disabled="disabled" />
        <label>{{ $t('terminals.announcements.content') }}</label>
        <b-form-textarea v-model="announcement.tiedoteTextList['1']" :disabled="disabled" rows="3" max-rows="6" />
        <b-form-group :label="$t('terminals.announcements.start_time')">
            <DateTimePicker v-model="announcement.kelpoisuusalkaa" :disabled="disabled" />
        </b-form-group>
        <b-form-group :label="$t('terminals.announcements.end_time')">
            <DateTimePicker v-model="announcement.kelpoisuusloppuu" :disabled="disabled" />
        </b-form-group>
        <FormButtons
            :submit="action == 'add'" @submit="onSubmit" :disableSubmit="action == 'remove'"
            @reset="onReset"
            :remove="action == 'remove'" @remove="onRemove"
            :deleteConfirmation="$t('terminals.announcements.remove_attachments_message')"></FormButtons>
        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>
</div>
</template>

<script>
import DateTimePicker from '@/components/Misc/DateTimePicker';
import terminalView from '@/store/terminals/terminalView';
import vSelect from 'vue-select';
import moment from 'moment';

export default {
	name: 'TermDispAnnouncementEditor',
    components: { DateTimePicker, vSelect },
    props: {
        selectedAnnouncement: {
            type: Object,
            //required: true,
            default: () => { return {
                    tunnus: -1,
                    otsikko: '',
                    tiedoteTextList: {}
                };
            }
        },
        terminalId: { required: true },
        displayId: { required: true },
        action: {
            type: String,
            required: true
        }
    },
    data: function() {
        return {
            // selectedAnnouncement is an initial value passed from the parent, announcement is used as the internal value.
            announcement: this.selectedAnnouncement,
            ok: false,
            error: false,
            loading: false,
            infoType: 'save'
        };
    },
    computed: {
        announcementOptions() {
            var optionList = [];
            optionList.push({
                    tunnus: -1,
                    otsikko: this.$t('terminals.announcements.create_new'),
                    tiedoteTextList: {}
                });
            optionList.push({
                    tunnus: -2,
                    otsikko: '-----',
                    tiedoteTextList: {}
                });
            /*
            for (var a of this.$store.state.terminalView.announcementsByTerminal[this.terminalId]) {
                optionList.push(a);
            }
            */
            return optionList;
        },
        disabled() {
            return this.loading || (this.announcement.tunnus && this.announcement.tunnus > -1);
        }
    },
    methods: {
        onSelect(selected) {
            // The internal announcement variable is replaced with a new object.
            //this.announcement = { ...this.announcement, ...selected };
            this.announcement = { ...selected };
            if (selected.tunnus == -1) {
                // Initialize validity time with the present moment when creating a new announcement.
                this.announcement.kelpoisuusalkaa = new moment().format('YYYY-MM-DD[T]HH:mm:ssZZ');
                this.announcement.kelpoisuusloppuu = this.announcement.kelpoisuusalkaa;
                this.announcement.otsikko = '';
            }
        },
        onSubmit(event) {
            if (event)
                event.preventDefault();
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;

            this.announcement.terminal = this.terminalId;
            this.announcement.targets = { displayTargets: [ { id: this.displayId } ] };
            this.announcement.tyyppi = 1;
            this.announcement.kiinnitystyyppi = 2;
            this.$store.dispatch('terminalView/addTerminalDisplayAnnouncement', { announcement: this.announcement,
                                                                        terminalId: this.terminalId })
            .then(response => {
                setTimeout(() => { 
                    this.loading = false;
                    if (response.data.errorCode == 0) {
                        this.onReset();
                    } else {
                        this.error = true;
                    }
                }, 1000);
            })
            .catch( () => { this.error = true; })
        },
        onReset() {
            this.ok = this.error = false;
            this.loading = false;
            this.$emit('reset');
        },
        onRemove() {
            this.ok = this.error = false;
            this.infoType = "delete";
            this.loading = true;

            this.announcement.terminal = this.terminalId;
            this.announcement.targets = { displayTargets: [ { id: this.displayId } ] };
            this.$store.dispatch('terminalView/removeTerminalDisplayAnnouncementAttachments', { announcement: this.announcement,
                                                                        terminalId: this.terminalId })
            .then(response => {
                setTimeout(() => { 
                    this.loading = false;
                    if (response.data.errorCode == 0) {
                        this.onReset();
                    } else {
                        this.error = true;
                    }
                }, 1000);
            }, () => {
                    this.ok = false;
                    this.error = !this.ok;
                    this.loading = false;
            });
        }
    },
    created() {
		if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }
    }
}
</script>